import $ from "jquery";
import { sliderSetting } from "@/shared/calendar";

document.addEventListener("DOMContentLoaded", () => {
  // カレンダーのカルーセル設定
  sliderSetting(false, false);

  // 日付選択にフォーカスした
  let $dateTarget = null; // 選択中の input

  document.querySelectorAll(".form-date__input").forEach((el) => {
    el.addEventListener("focus", (e) => {
      $dateTarget = $(e.currentTarget);
      $(".calendar, .calendar__bg").show();
      $(".js-slick__list.slick-initialized").slick("refresh"); // 非表示要素にslick再適応
    });
  });

  // 希望日を選択した
  document.querySelector(".calendar")?.addEventListener("click", (e) => {
    const target = e.target.closest(".calendar__day-item"); // クリックされた要素を判定
    if (target && !target.classList.contains("is-disabled")) {
      const date = target.querySelector("input")?.value;

      if (date && date.length) {
        // フォームに日付の入力
        $dateTarget.val(date);
        $(".calendar__day-item input[type='checkbox']").prop("checked", false); // 日付のチェック解除
        $(".calendar, .calendar__bg").hide(); // カレンダー閉じる
      }
    }
  });
  // 第一希望日のバツボタンをクリックした際、第一希望日の日付と時刻をリセット
  document.querySelectorAll(".js-date_cancel1").forEach((element) => {
    element.addEventListener("click", () => {
      document.getElementById("preferred_date1").value = "";
      if (document.getElementById("reserve_time1")) {
        document.getElementById("reserve_time1").value = "";
      } else if (
        document.getElementById("reserve_hour1") &&
        document.getElementById("reserve_minute1")
      ) {
        document.getElementById("reserve_hour1").value = "";
        document.getElementById("reserve_minute1").value = "";
      }
    });
  });

  // 時刻（時）を変更したとき 00分にセット[通常予約・資料請求のみ]
  document.querySelectorAll("[id^='reserve_hour']").forEach((el) => {
    el.addEventListener("change", (e) => {
      const $target = $(e.currentTarget);
      const timeTarget = $target
        .prop("id")
        .replace("reserve_hour", "#reserve_minute"); // 対応する[分]
      $(timeTarget).val("00");
    });
  });

  // カレンダーモーダル背景押下でカレンダー閉じる
  document.querySelectorAll(".calendar__bg, .calendar__close").forEach((el) => {
    el.addEventListener("click", () => {
      $(".calendar, .calendar__bg").hide();
      return false;
    });
  });

  // EnterでSubmitされるのを防ぐ
  document.querySelectorAll("form:not([data-enableSubmit])").forEach((form) => {
    form.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        return false;
      }
      return true;
    });
  });
});
